import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-46">
      {/* Ambient Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-glow from-purple-900/20 via-zinc-950/0 to-transparent opacity-50 pointer-events-none blur-3xl" data-id="element-47" />

      <div className="relative z-10 max-w-5xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-48">
        {/* Copy Column */}
        <div className="flex flex-col items-start text-left space-y-8" data-id="element-49">
          <FadeIn data-id="element-50">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight" data-id="element-51">
              Chakra Reset: El Protocolo de 7 Días para Salir del Bucle y
              Recuperar tu Poder
            </h1>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-52">
            <h2 className="text-xl sm:text-2xl text-zinc-400 font-serif italic" data-id="element-53">
              Libera la pesadez emocional, silencia el sobrepensar y desbloquea
              tu autoestima mediante el Método de Sacudida Somática.
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} className="space-y-4 text-zinc-300 text-base sm:text-lg leading-relaxed" data-id="element-54">
            <p data-id="element-55">
              Son las 2:00 AM y tu mente no se apaga. Repites ese error, esa
              conversación, esa duda… sintiendo un peso en el pecho que te dice
              que, por más que lo intentes, siempre estarás "atascada".
            </p>
            <p data-id="element-56">
              Ese bloqueo no está en tus circunstancias, está atrapado en tu
              cuerpo. No puedes pensar tu salida de un laberinto emocional;
              tienes que mover tu salida.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="w-full sm:w-auto pt-4" data-id="element-57">
            <Button size="lg" fullWidth className="group" onClick={scrollToOffer} data-id="element-58">
              ¡QUIERO DESBLOQUEAR MI PODER AHORA!
            </Button>
            <p className="text-xs text-zinc-500 mt-3 text-center sm:text-left" data-id="element-59">
              Acceso instantáneo. Empieza tu Día 1 en los próximos 2 minutos.
            </p>
          </FadeIn>
        </div>

        {/* Image Column */}
        <FadeIn delay={0.4} direction="left" className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-60">
          <div className="relative aspect-[4/3] w-full" data-id="element-61">
            <div className="absolute inset-0 bg-gradient-to-tr from-purple-500/10 to-transparent rounded-2xl blur-2xl" data-id="element-62" />
            <img src="https://cdn.magicpatterns.com/uploads/aWcxLnrCfuSmSCPFy5Y7LS/heylloyd-image-1780533195567.png" alt="Chakra Reset - 7 Días de Desbloqueo, ebook digital" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-63" />
          </div>
        </FadeIn>
      </div>
    </section>;
}